module.exports = __webpack_public_path__ + "img/TerrainThumbnail.2c3bb92e.png";